export default __webpack_public_path__ + "static/media/003.0ef21edb.jpg";